import request from '@/config/request'

export default {
    getMpAuthUserInfo: function (params) {
        return request({
            url: '/common/wechat/getmpauthuserinfo',
            method: 'post',
            params: params

        })
    },

    initWechatAuth: function (params) {
        return request({
            url: '/common/wechat/initwechatauth',
            method: 'post',
            params: params
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/common/wechat.js